import { DestroyRef, inject, Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { exhaustMap } from 'rxjs/operators';

import { EventBusPort } from '@platform/event-bus/domain/ports/event-bus.port';
import { CartOrderUnpaidEvent } from '@platform/event-bus/domain/events/cart/cart-order-unpaid.event';
import { ResumePaymentUseCase } from '../use-cases/resume-payment.use-case';

@Injectable({ providedIn: 'root' })
export class PaymentOnOrderUnpaidSubscriber {
  private readonly destroyRef = inject(DestroyRef);
  private readonly eventBus = inject(EventBusPort);
  private readonly resumePayment = inject(ResumePaymentUseCase);

  constructor() {
    this.eventBus
      .ofType(CartOrderUnpaidEvent)
      .pipe(
        exhaustMap(({ payload }) => this.resumePayment.execute({ order: payload.order })),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe();
  }
}
